import axios from 'axios';
import API_ENDPOINTS from '../constants/api_endpoints';

const TEMP_HEADERS_PATHS = [API_ENDPOINTS.AUTH.ReSendOtp, API_ENDPOINTS.AUTH.ValidateOtp]

const realBricksApi = axios.create({
  baseURL: API_ENDPOINTS.baseURL,
});

realBricksApi.interceptors.request.use(
  (config) => {
    const options = { ...config };
    options.headers['Accept'] = 'application/json';
    options.headers['Content-Type'] = 'application/json';
    options.headers['ngrok-skip-browser-warning'] = true;    

    if (TEMP_HEADERS_PATHS.indexOf(config.url) !== -1) {
      if (localStorage.getItem('access_token_temp')) {
        const token = localStorage.getItem('access_token_temp');
        options.headers['Authorization'] = `Bearer ${token}`;
      }
    }
    else if (localStorage.getItem('access_token')) {      
      const token = localStorage.getItem('access_token');
      options.headers['Authorization'] = `Bearer ${token}`;
    }
    return options;
  },
  (error) => {
    return Promise.reject(error);
  }
);
realBricksApi.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.data.isError && error.response.status === 403 || error.response.status === 401) {
      localStorage.clear()
      window.location.href = '/login';
    } else {
  
      return Promise.reject(error);
    }
  }
);
const get = (url) => realBricksApi.get(url);

// const post = (url, body) => realBricksApi.post(url, body);

// const put = (url, body) => realBricksApi.put(url, body);

// const del = (url, body) => realBricksApi.delete(url, { data: body });

export { get, realBricksApi };

